/* SafeStap · video reviews slider: arrows, one video with sound at a time,
   optional muted previews while visible. */
if (!customElements.get('ss-video-slider')) {
  class SsVideoSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ss-vr__track');
      if (!this.track) return;
      this.prevButton = this.querySelector('.ss-vr__arrow--prev');
      this.nextButton = this.querySelector('.ss-vr__arrow--next');
      this.autoplay = this.dataset.autoplay === 'true';

      this.onScroll = this.updateArrows.bind(this);
      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);

      this.querySelectorAll('.ss-vr__card').forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('.ss-vr__play');
        if (!video || !button) return;
        button.addEventListener('click', () => this.play(card, video));
        video.addEventListener('playing', () => card.classList.add('is-previewing'));
      });

      if (this.autoplay && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (video.closest('.ss-vr__card').classList.contains('is-playing')) return;
              if (entry.isIntersecting) {
                video.muted = true;
                video.play().catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.6 }
        );
        this.querySelectorAll('.ss-vr__video').forEach((video) => this.observer.observe(video));
      }

      this.updateArrows();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    go(direction) {
      const item = this.track.querySelector('.ss-vr__item');
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = item.offsetWidth + gap;
      const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      this.track.scrollBy({ left: direction * step * perPage, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prevButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= max;
    }

    play(card, video) {
      document.querySelectorAll('.ss-vr__card.is-playing').forEach((other) => {
        if (other === card) return;
        const otherVideo = other.querySelector('video');
        other.classList.remove('is-playing');
        if (!otherVideo) return;
        otherVideo.controls = false;
        const slider = other.closest('ss-video-slider');
        if (slider && slider.dataset.autoplay === 'true') {
          otherVideo.muted = true;
        } else {
          otherVideo.pause();
        }
      });

      card.classList.add('is-playing');
      video.controls = true;
      video.muted = false;
      video.play().catch(() => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }
  }

  customElements.define('ss-video-slider', SsVideoSlider);
}
